var ScreeningExecutionResult = /** @class */ (function () {
    function ScreeningExecutionResult() {
        this.companyId = null;
        this.feedbackAnswersList = [];
        this.jobDetailsRecruiterScreeningList = [];
        this.companyAndOverallComplete;
        this.fromButton;
        this.meetingScheduleId;
        this.externalMeetingId;
    }
    return ScreeningExecutionResult;
}());
export { ScreeningExecutionResult };
//# sourceMappingURL=screeningExecutionResult.js.map